export const columns = [
  {
    title: '排序',
    dataIndex: 'list_order',
    scopedSlots: { customRender: 'list_order' },
    width: '150px',
  },
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '分类名称',
    dataIndex: 'name',
  },
  {
    title: '所属科室',
    dataIndex: 'department_name',
  },
  {
    title: '栏目简介',
    dataIndex: 'post_content',
  },
  {
    title: '状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData = [
  {
    name: 'parent_id',
    lable: '上级分类',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'name',
    lable: '栏目名称',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'department_id',
    lable: '所属科室',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'post_content',
    lable: '栏目简介',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'cover',
    lable: '背景图',
    lableCol: 4,
    wrapperCol: 18,
  },
  {
    name: 'list_order',
    lable: '排序',
    lableCol: 4,
    wrapperCol: 18,
  },
];